export default __webpack_public_path__ + "static/media/antelope.f09dcba8.jpg";